var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Poster"},[_c('div',{staticClass:"Poster__test"},[_c('img',{attrs:{"src":require('@/commons/img/poster.png')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }